import React from "react";

const SearchFilter = ({ search, setSearch }) => {
  return (
    <div className="relative w-full max-w-full mb-1">
      <input
        type="search"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        placeholder="Design Shade..."
        style={{ border:"1px solid #ece9e9"}}
        className="w-full pl-10 pr-4 py-1 border-gray-300 rounded-sm focus:outline-none"
      />

      <div
        className="absolute inset-y-0 left-0 pl-2 d-flex align-items-center"
        style={{ color: "rgb(146 146 146)" }}
      >
        <i className="bi bi-search"></i>
      </div>
    </div>
  );
};

export default SearchFilter;